import { IconBell } from '@tabler/icons-react';
import classes from './_gridLayout.module.css';

export function A4() {
  return (
    <div className={classes.gridA4}>
      <IconBell size={20} stroke={1.5} />
    </div>
  );
} 